import { render, staticRenderFns } from "./TranslateModal.vue?vue&type=template&id=66469de4&"
import script from "./TranslateModal.vue?vue&type=script&lang=js&"
export * from "./TranslateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports